var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    overflow: "visible",
    enableBackground: "new 0 0 144 144",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Review"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Review_1_",
    fill: "#7bc4a3",
    d: "M70.866,2.268C31.728,2.268,0,33.996,0,73.134C0,112.272,31.728,144,70.866,144 c39.139,0,70.866-31.728,70.866-70.866C141.732,33.996,110.005,2.268,70.866,2.268z M28.375,80.438h-13.75v-32.75h13.75V80.438z  M32.25,47.82C42.952,40.146,48.765,33.908,52,25.333c3.333-8.833-2.084-14.283,5.5-15.125c3.75-0.417,10.198,5.844,4.906,27.51 c-0.995,4.075,13.011,1.615,18.511,3.115s9.177,7.807,2.771,11.385c-0.843,0.471-0.534,1.313,0.297,1.281 c4.349-0.167,11.558,10.625-1.391,11.938c-0.296,0.03-0.357,0.486,0.094,0.667c9.344,3.739,3.797,11.661-2.969,11.442 c-0.221-0.007-0.547,0.516,0.078,0.844c6.249,3.281,0.745,11.234-4.964,11.026c-8.323-0.304-27.095,2.387-42.583-9.247V47.82z  M109.406,99.021c-10.702,7.675-16.515,13.913-19.75,22.487c-3.333,8.833,2.084,14.282-5.5,15.125 c-3.75,0.416-10.198-5.844-4.906-27.511c0.995-4.074-13.011-1.614-18.511-3.114s-9.177-7.808-2.771-11.386 c0.142-0.079,0.24-0.17,0.319-0.264c6.475,0.319,12.069-0.085,15.777,0.051c6.285,0.229,14.45-5.034,12.981-13.098 c-0.103-0.563,0.018-0.608,0.5-0.875c7.745-4.271,3.762-13.202,3.984-13.406c2.588-2.381,3.3-5.17,2.875-7.58 c5.042,1.368,10.18,3.6,15,7.221V99.021z M113.281,99.154v-32.75h13.75v32.75L113.281,99.154z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.7da63246.svg";
export { ForwardRef as ReactComponent };